import { render, staticRenderFns } from "./GJgrowEventCreateTermEventDate.vue?vue&type=template&id=5c788860&scoped=true&"
import script from "./GJgrowEventCreateTermEventDate.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateTermEventDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c788860",
  null
  
)

export default component.exports